import $moment from 'moment'
import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'contract',
  namespaced: true,
  state: {
    current: null,
    limitTransaction: null,
  },
  getters: {
    remainExpireDays() {},
  },
  mutations: {
    setLimitTransaction(state, limitTransaction) {
      state.limitTransaction = limitTransaction
      let remainExpireDays
      if (state.limitTransaction.expireDate) {
        const expireDate = $moment(new Date(state.limitTransaction.expireDate))
        const now = $moment(Date.now())
        remainExpireDays = expireDate.diff(now, 'days')
        console.log('diff', remainExpireDays)
      }
      state.limitTransaction.remainExpireDays = remainExpireDays
    },
    setCurrent(state, current) {
      state.current = current
    },
  },
  actions: {
    async contractComplete({ dispatch }) {
      const { data } = await defaultApi.postContractComplete()
      // 현재상태를 갱신한다
      await dispatch('getCurrent')
      return data
    },
    async getCurrent({ commit }) {
      const { data } = await defaultApi.getContractCurrent()
      commit('setCurrent', data)
      return data
    },
    async getLimitTransaction({ commit }) {
      const { data } = await defaultApi.getContractAgreementsLimitTransaction()
      commit('setLimitTransaction', data)
      return data
    },
    async checkExistContract({}, contract) {
      if (!contract.isAgreed) {
        return false
      }
      const { expireDate } = contract
      if (expireDate) {
        const diffDays = $moment(expireDate).diff($moment($moment().format('yyyy-MM-DD')), 'days')
        if (diffDays < 0) {
          return false
        }
      }

      return true
    },
  },
}
